import { defineStore } from 'pinia'
import { LimitedArray } from '~/utils/limitedList'

// oFetch doesn't expose their types, this is an estimation of their type
interface NetworkError {
  readonly _data?: object
  readonly headers: any
  readonly ok: boolean
  readonly redirected: boolean
  readonly status: number
  readonly statusText: string
  readonly type: string
  readonly url: string
  readonly timestamp?: string
}

interface State {
  networkErrors: LimitedArray<NetworkError>
  hasMadeCookieDecision: boolean
}

export const useUrlHistoryStore = defineStore('urlHistory', {
  state: (): State => ({
    networkErrors: new LimitedArray(20),
    hasMadeCookieDecision: false
  }),
  actions: {
    pushNetworkError(error: NetworkError) {
      this.networkErrors.push({
        timestamp: dayjsUTC().toString(),
        ...error
      })
    }
  }
})

/**
 * Pinia supports Hot Module replacement, so you can edit your stores and
 * interact with them directly in your app without reloading the page.
 *
 * @see https://pinia.esm.dev/cookbook/hot-module-replacement.html
 * @see https://vitejs.dev/guide/api-hmr.html
 */
if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useUrlHistoryStore as any, import.meta.hot))
}
